// extracted by mini-css-extract-plugin
export default {"articles":"articles_articles__eZ8K-","createButton":"articles_createButton__wK6UO","error-message":"articles_error-message__K+Ua+"};